import React from 'react'
import '../App.css'
import { Canvas } from '@react-three/fiber';
import Background from './Background';
import {OrbitControls} from '@react-three/drei';
import Profile from './Profile';
import EditBox from './EditBox';
import DragLine from './DragLine';

function Sketch() {
  return (
    <div className = "sketch">
      <Canvas 
          invalidateFrameloop 
          orthoghaphic={true} 
          camera={{position:[0,0,200], left:-1, right:1, top:1, bottom:-1}} 
          className='canvas'
        >

          <ambientLight intensity={1} color={0xFFFFFF}/>
          <Background />
          <Profile />
          <DragLine />
          <EditBox />
          <axesHelper />
          {/* <OrbitControls /> */}
        </Canvas>
    </div>
  )
}

export default Sketch
